/**
 * Consumer Price Index for All Urban Consumers (CPI-U), U.S. city average, all items,
 * not seasonally adjusted, ANNUAL AVERAGES, 1982–84 = 100.
 *
 * Series ID: CUUR0000SA0 (annual average is period M13 in the BLS time series).
 * Source: U.S. Bureau of Labor Statistics, Public Data API
 *   https://api.bls.gov/publicAPI/v1/timeseries/data/  (series CUUR0000SA0, annualaverage=true)
 * The same series is published at https://data.bls.gov/timeseries/CUUR0000SA0
 * Retrieved: 2026-10-16 (CPI release through September 2026).
 *
 * BLS publishes 1913–2006 to one decimal place and 2007 onward to three. 2026 is not
 * included because the year is incomplete.
 *
 * October 2025 was never collected (BLS: data unavailable due to the 2025 lapse in
 * appropriations), so BLS computes the 2025 annual average (321.943) as the mean of the
 * eleven published monthly values; checked against the monthly series on the retrieval date.
 *
 * Do not edit these values by hand; re-fetch the series and update the date above.
 */
export const CPI_U_ANNUAL: Readonly<Record<number, number>> = {
  1913: 9.9,
  1914: 10.0,
  1915: 10.1,
  1916: 10.9,
  1917: 12.8,
  1918: 15.1,
  1919: 17.3,
  1920: 20.0,
  1921: 17.9,
  1922: 16.8,
  1923: 17.1,
  1924: 17.1,
  1925: 17.5,
  1926: 17.7,
  1927: 17.4,
  1928: 17.1,
  1929: 17.1,
  1930: 16.7,
  1931: 15.2,
  1932: 13.7,
  1933: 13.0,
  1934: 13.4,
  1935: 13.7,
  1936: 13.9,
  1937: 14.4,
  1938: 14.1,
  1939: 13.9,
  1940: 14.0,
  1941: 14.7,
  1942: 16.3,
  1943: 17.3,
  1944: 17.6,
  1945: 18.0,
  1946: 19.5,
  1947: 22.3,
  1948: 24.1,
  1949: 23.8,
  1950: 24.1,
  1951: 26.0,
  1952: 26.5,
  1953: 26.7,
  1954: 26.9,
  1955: 26.8,
  1956: 27.2,
  1957: 28.1,
  1958: 28.9,
  1959: 29.1,
  1960: 29.6,
  1961: 29.9,
  1962: 30.2,
  1963: 30.6,
  1964: 31.0,
  1965: 31.5,
  1966: 32.4,
  1967: 33.4,
  1968: 34.8,
  1969: 36.7,
  1970: 38.8,
  1971: 40.5,
  1972: 41.8,
  1973: 44.4,
  1974: 49.3,
  1975: 53.8,
  1976: 56.9,
  1977: 60.6,
  1978: 65.2,
  1979: 72.6,
  1980: 82.4,
  1981: 90.9,
  1982: 96.5,
  1983: 99.6,
  1984: 103.9,
  1985: 107.6,
  1986: 109.6,
  1987: 113.6,
  1988: 118.3,
  1989: 124.0,
  1990: 130.7,
  1991: 136.2,
  1992: 140.3,
  1993: 144.5,
  1994: 148.2,
  1995: 152.4,
  1996: 156.9,
  1997: 160.5,
  1998: 163.0,
  1999: 166.6,
  2000: 172.2,
  2001: 177.1,
  2002: 179.9,
  2003: 184.0,
  2004: 188.9,
  2005: 195.3,
  2006: 201.6,
  2007: 207.342,
  2008: 215.303,
  2009: 214.537,
  2010: 218.056,
  2011: 224.939,
  2012: 229.594,
  2013: 232.957,
  2014: 236.736,
  2015: 237.017,
  2016: 240.007,
  2017: 245.12,
  2018: 251.107,
  2019: 255.657,
  2020: 258.811,
  2021: 270.97,
  2022: 292.655,
  2023: 304.702,
  2024: 313.689,
  2025: 321.943,
};

export const CPI_U_FIRST_YEAR = 1913;
export const CPI_U_LAST_YEAR = 2025;
